import React from 'react';
import {Card, Switch, Typography} from 'antd';
import styles from './index.less';

const { Text } = Typography;

export interface ToggleCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  checked?: boolean;
  value?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
  /** Rendered below the row, e.g. settings revealed while the toggle is on. */
  children?: React.ReactNode;
}

const ToggleCard: React.FC<ToggleCardProps> = ({
  title,
  description,
  checked,
  value,
  disabled,
  onChange,
  className,
  style,
  children,
}) => {
  const isChecked = checked !== undefined ? checked : value;

  return (
    <Card
      size={"small"}
      className={className || styles.toggleCard}
      style={style}
    >
      <div className={styles.toggleCardContent}>
        <div className={styles.toggleCardText}>
          <div className={styles.toggleCardTitle}>
            {title}
          </div>
          {description && (
            <Text type="secondary" className={styles.toggleCardDescription}>
              {description}
            </Text>
          )}
        </div>
        <Switch checked={isChecked} disabled={disabled} onChange={onChange} />
      </div>
      {children}
    </Card>
  );
};

export default ToggleCard;
